//
// Checks if the given value is null or undefined
//
const isNil = (value: any) => value === null || value === undefined;

export default isNil;
